/* Braveboi Social Club: scroll reveals, emboss lighting, gentle parallax. */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal on scroll
  const reveals = document.querySelectorAll('.bb-reveal');
  if ('IntersectionObserver' in window && reveals.length && !reduce) {
    root.classList.add('bb-reveal-ready');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach((el) => io.observe(el));
  }

  // Emboss lighting: the light follows the pointer, shadows fall away from it
  const light = (stage, mark, nx, ny) => {
    const set = (k, v) => mark.style.setProperty(k, v);
    set('--hx', (nx * -1.8).toFixed(2) + 'px');
    set('--hy', (ny * -1.8).toFixed(2) + 'px');
    set('--sx', (nx * 2.8).toFixed(2) + 'px');
    set('--sy', (ny * 2.8 + 0.6).toFixed(2) + 'px');
    set('--dx', (nx * 10).toFixed(1) + 'px');
    set('--dy', (ny * 12 + 4).toFixed(1) + 'px');
    set('--mx', (50 - nx * 35).toFixed(1) + '%');
    set('--my', (45 - ny * 35).toFixed(1) + '%');
    set('--rx', (ny * -3).toFixed(2) + 'deg');
    set('--ry', (nx * 4).toFixed(2) + 'deg');
    stage.style.setProperty('--lx', 50 - nx * 30 + '%');
    stage.style.setProperty('--ly', 35 - ny * 20 + '%');
  };

  document.querySelectorAll('[data-bb-emboss-stage]').forEach((stage) => {
    const marks = [...stage.querySelectorAll('.bb-emboss')];
    if (!marks.length) return;
    const mark = { style: { setProperty: (k, v) => marks.forEach((m) => m.style.setProperty(k, v)) } };
    const rest = () => light(stage, mark, 0.45, 0.55);
    rest();
    if (reduce) return;
    stage.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = stage.getBoundingClientRect();
      light(stage, mark, -((e.clientX - r.left) / r.width * 2 - 1), -((e.clientY - r.top) / r.height * 2 - 1));
    });
    stage.addEventListener('pointerleave', rest);
  });

  // Parallax: elements drift at their own speed as you scroll
  const drifters = [...document.querySelectorAll('[data-bb-drift]')];
  if (drifters.length && !reduce) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      drifters.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const speed = parseFloat(el.dataset.bbDrift) || 0.1;
        el.style.setProperty('--py', ((r.top + r.height / 2 - vh / 2) * -speed).toFixed(1) + 'px');
      });
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }
})();
